import React, { useState ,useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstance from '../../configuration/request';
import TextFieldCustom from '../elements/textfieldCustom';
import CustomAutocomplete from '../elements/CustomeAutocomplete';
import CustomButton from '../elements/CustomButton/CustomButton';



function CreateRole({ onClose ,onSubmit,dialogDetails }) {
  const [permissions, setPermissions] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [selectedPermission, setSelectedPermission] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    try {
      let url = ``;

      if (
        dialogDetails?.userType === "business user" &&
        dialogDetails.storeId
      ) {
        url += `auth/rbac/permissions?storeId=${dialogDetails.storeId}`;
      }else if( dialogDetails?.userType === "admin"){
          url = `auth/rbac/permissions`;
      }
      const res = await axiosInstance.get(url);
      let formattedPermissions = [];
      if (dialogDetails?.userType === "business user") {
        formattedPermissions = res?.data?.map((item) => ({
           value: item?.id,
          label: item?.resource?.split(":")[1]?.replace(/_/g, " ") + ":" + item?.action.join(","),
        }));
      } else {
        formattedPermissions = res?.data?.map((item) => ({
          value: item?.id,
          label: item?.resource + ":" + item?.action.join(","),
        }));
      }
      setPermissions(formattedPermissions);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };
  const handleSubmit = () => {
    let payload = {
      name: roleName,
      permissionIds:selectedPermission.map((item) => item.value),
    }
      let url = `${process.env.REACT_APP_BASE_URL}auth/rbac/create-role`

      if (
        dialogDetails?.userType === "business user" &&
        dialogDetails.storeId
      ) {
        url += `?storeId=${dialogDetails.storeId}`;
      }
   axiosInstance
      .post(url,payload)
      .then((res) => {
         onSubmit()
      })
      .catch((err) => console.log(err))
  };

  const handleChange = (key) => (value) => {

    setRoleName( value );
  };

 const handleSelect = (value) => {
    if (value) {
      setSelected(value)
      setSelectedPermission((prev) => {
        if (!prev.includes(value)) {
          return [...prev, value];
        }
        return prev;
      });
    } else {
      setSelected(null);

    }

  }

  return (
    <div className="pt-6 px-10">
      <div className="flex justify-between mb-6">
        <div className="text-lg font-[500]">Create Role</div>
        <button
          className="text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="flex flex-col my-4 w-full justify-center items-center">
        <div className="flex flex-wrap items-end gap-6 mb-4 w-full">
          <TextFieldCustom
            label="Role Name*"
            fullWidth
            value={roleName}
            onChange={(e) => handleChange('roleName')(e.target.value)}
          />

          <div className='w-full' >
            <CustomAutocomplete
              label="Assign Permissions"
              value={selected}
              onChange={handleSelect}
              options={permissions}
              multiple
            />
          </div>

        </div>

        {/* Selected Permission Display */}
        {selectedPermission.length > 0 && (
          <div className="w-full  text-sm text-gray-700">
            <span className="font-semibold">Selected:</span>
            <div className="flex flex-wrap gap-2 mt-2">
              {selectedPermission.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full border border-blue-300"
                >
                  {item.label}
                  <button
                    className="text-blue-600 hover:text-red-500 ml-2"
                    onClick={() =>
                      setSelectedPermission((prev) =>
                        prev.filter((_, i) => i !== index)
                      )
                    }
                  >
                    &times;
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}


        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-center items-center mt-8 mb-4 gap-3">
          <CustomButton
            onClick={onClose}
            customeClass="primary-custom-button w-full sm:w-[150px] h-[40px]"
          >
            Cancel
          </CustomButton>
          <CustomButton
            onClick={handleSubmit}
            customeClass="gradient-button w-full sm:w-[150px] h-[40px]"
            disabled={!roleName || !selectedPermission.length === 0}
          >
            Create
          </CustomButton>
        </div>
      </div>
    </div>
  );
}

export default CreateRole;
